export const AuthCheckbox = ({ testid, checked, onChange, label, className }) => (
  <label data-testid={`${testid}-label`} className={className}
    style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8, marginTop: -4, fontSize: 13, fontWeight: 500, cursor: "pointer", textTransform: "none", letterSpacing: "normal", fontFamily: "inherit", color: "#334155" }}>
    <input data-testid={testid} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)}
      style={{ width: 16, height: 16, margin: 0, padding: 0, cursor: "pointer", accentColor: "#1D4ED8" }}/>
    {label}
  </label>
);
